import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { can } from '../../../../../../services';
import { requestPhaseItems, navigate } from 'actionCreators';
import MediaQuery from 'react-responsive';
import modal from 'modal.scss';
import { Dialog, IconButton } from 'react-toolbox';
import ColoredButton from 'components/ColoredButton';
import PhaseStatus from 'phaseStatus';
import ImsStatus from './imsStatus';
import PhaseTasks from './phaseTasks';
import S from 'phaseTaskBar.scss';
import { ResourceDetailsCardElement } from 'components/ResourceCardElements';
import FlagList from 'flagList';
import { urls } from 'helpers/url';
import PhaseType from 'types/phase';

const MINIMUM_WIDTH = 920;

class PhaseTaskBar extends React.Component {
  constructor(props) {
    super(props);
    this.handleTasksClose = this.handleTasksClose.bind(this);
  }

  state = { taskModalOpen: false, flagModalOpen: false }

  componentWillMount = () => {
    const { phase: { type, status, id: phaseId } } = this.props;
    return type === 'Installation' && status === 'installing' ? requestPhaseItems(phaseId, 'laborSheets') : null;
  };

  phaseTasksAvailable = (role, status) => can(role, 'update', 'phase_task', { status })

  handleTasksOpen = () => this.setState({ taskModalOpen: true });
  handleTasksClose = () => this.setState({ taskModalOpen: false });
  handleFlagsOpen = () => this.setState({ flagModalOpen: true });
  handleFlagsClose = () => this.setState({ flagModalOpen: false });

  render = () => {
    const {
      phase,
      role,
      employeeType,
    } = this.props;
    return (<div className={S.phaseTaskBar}>
      <div className={S.phaseTaskBar__statusColumn}>
        <PhaseStatus phase={phase} />
      </div>
      {['IMS', 'IFI', 'Manual'].includes(phase.source) && (
        <div className={S.phaseTaskBar__imsStatusColumn}>
          <ImsStatus phase={phase} role={role} />
        </div>
      )}
      {phase.pending_quick_schedule_response && (
        <span className={S.pendingQuickScheduleBadge}>
          Pending Customer Confirmation
        </span>
      )}

      <MediaQuery minWidth={MINIMUM_WIDTH}>
        <div className={S.phaseTaskBar__infoContainer}>
          {this.phaseTasksAvailable(role, phase.status) && <PhaseTasks
            phase={phase} role={role} handleTasksClose={this.handleTasksClose}
            employeeType={employeeType}
          />}
          {can(role, 'view', 'flag') && <ResourceDetailsCardElement
            title="Flags" wrap className={S.phaseTaskBar__flagsContainer}
          >
            <FlagList
              flags={phase.flags}
              deleteEnabled={can(role, 'delete', 'flag')}
              onFlagNavigate={() => this.props.navigate(urls.phaseCommunications(phase))}
            />
            {phase.flags.length === 0 && '--'}
          </ResourceDetailsCardElement>}
        </div>
      </MediaQuery>
      <MediaQuery maxWidth={MINIMUM_WIDTH - 1}>
        <span>
          {this.phaseTasksAvailable(role, phase.status) && <ColoredButton
            onClick={this.handleTasksOpen} color="blue"
          >View Current Tasks</ColoredButton>}
          {' '}
          {can(role, 'view', 'flag') && <ColoredButton
            onClick={this.handleFlagsOpen} color="blue"
          >View Flags</ColoredButton>}
        </span>
        <Dialog
          active={this.state.taskModalOpen}
          className={modal.modal}
          onEscKeyDown={this.handleTasksClose}
          onOverlayClick={this.handleTasksClose}
        >
          <IconButton
            icon="close"
            className={modal.close}
            onClick={this.handleTasksClose}
          />
          <h2 className={modal.title}>Current Tasks</h2>
          <PhaseTasks
            phase={phase}
            role={role}
            handleTasksClose={this.handleTasksClose}
            employeeType={employeeType}
          />
        </Dialog>
        <Dialog
          active={this.state.flagModalOpen}
          className={modal.modal}
          onEscKeyDown={this.handleFlagsClose}
          onOverlayClick={this.handleFlagsClose}
        >
          <IconButton
            icon="close"
            className={modal.close}
            onClick={this.handleFlagsClose}
          />
          <h2 className={modal.title}>Flags</h2>
          <FlagList
            flags={phase.flags}
            deleteEnabled={can(role, 'delete', 'flag')}
            onFlagNavigate={() => this.props.navigate(urls.phaseCommunications(phase))}
          />
        </Dialog>
      </MediaQuery>
    </div>);
  }
}

PhaseTaskBar.propTypes = {
  phase: PhaseType.isRequired,
  role: PropTypes.string.isRequired,
  employeeType: PropTypes.string,
  navigate: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, { requestPhaseItems, navigate })(PhaseTaskBar);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/phaseTaskBar.jsx